import Vue from 'vue'
import './plugins/amap'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import echarts from 'echarts'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

import socketApi from "./utils/websocket";

Vue.prototype.$wsApi = socketApi;
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer)
Vue.directive('draggable', {
  bind(el) {
    el.style.position = 'fixed';
    el.style.cursor = 'move';
    
    el.onmousedown = function(e) {
      // 阻止默认事件，避免拖拽时选中文本
      e.preventDefault();
      
      // 计算鼠标相对元素的位置
      const disX = e.clientX - el.offsetLeft;
      const disY = e.clientY - el.offsetTop;
      
      document.onmousemove = function(e) {
        e.preventDefault();
        
        // 计算新位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        
        // 限制边界（可选）
        const maxLeft = window.innerWidth - el.offsetWidth;
        const maxTop = window.innerHeight - el.offsetHeight;
        
        left = Math.min(Math.max(0, left), maxLeft);
        top = Math.min(Math.max(0, top), maxTop);
        
        // 设置新位置
        el.style.left = left + 'px';
        el.style.top = top + 'px';
      };
      
      document.onmouseup = function() {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});
new Vue({
    router,
	store,
    render: function(h) { return h(App) },
}).$mount('#app')